import React, { Component } from 'react';
import jwt_decode from "jwt-decode";
import instance from "./axios-instance";
import Swal from 'sweetalert2';
import Systems from "./SystemFunction";
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

const BASE = '/idea-bet.live/theme/ufa7/';

const GOLD = '#FBDEB2';
const GOLD2 = '#ECCA77';
const BTN_GOLD = 'linear-gradient(270.03deg, rgb(139,104,50) 0.05%, rgb(252,221,154) 51.59%, rgb(150,107,42) 100%), linear-gradient(0deg, rgb(236,202,119), rgb(236,202,119))';
// พื้นการ์ดฟอร์ม เหมือนต้นฉบับ
const FORM_BG = 'linear-gradient(0deg, rgba(127,126,118,0.75) -0.04%, rgba(23,21,22,0.75) 0px, rgba(97,97,95,0.75) 97.15%)';

const COUNTRIES = [
    { flag: 'kh', dial: '+855', name: 'Cambodia' },
    { flag: 'id', dial: '+62', name: 'Indonesia' },
    { flag: 'kr', dial: '+82', name: 'Korea' },
    { flag: 'la', dial: '+856', name: 'Laos' },
    { flag: 'my', dial: '+60', name: 'Malaysia' },
    { flag: 'mm', dial: '+95', name: 'Myanmar' },
    { flag: 'sg', dial: '+65', name: 'Singapore' },
    { flag: 'th', dial: '+66', name: 'ประเทศไทย / Thailand' },
    { flag: 'vn', dial: '+84', name: 'Vietnam' },
];
const REFERRALS = ['All website', 'Facebook', 'Google', 'YouTube', 'TikTok', 'Line', 'เพื่อนแนะนำ'];
const STEP = { BASIC: 1, OTP: 2, BANK: 3, SUCCESS: 4 };

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            otpEnabled: false,   // <<< Flag เปิด/ปิด สเต็ป OTP

            loading: false,
            stateregis: STEP.BASIC,
            showpass: false,

            username: "",
            password: "",
            phoneNumber: "",
            phoneCode: '+66',
            phoneFlag: 'th',
            country: { flag: 'th', name: 'ประเทศไทย / Thailand' },
            referral: 'All website',
            countrySearch: "",
            showCountry: false,
            showReferral: false,
            showLang: false,

            otp: "",
            refCode: "",
            countdown: 0,

            dropdownVisible: false,
            selectedBank: {},
            tblbank: [],            // รายการธนาคารจาก API (mainsetting)
            accnumbertxt: "",
            fname: "",
            needName: false,

            logoimg: "",
            linelink: "",
            userrecomend: "",
        };
        this.timer = null;
        this.forgetotpandregister = this.forgetotpandregister.bind(this);
    }

    onChange = (e) => this.setState({ [e.target.name]: e.target.value });
    onChangex = (e) => { if (e.target) this.setState({ [e.target.name]: e.target.value }); };
    changepass = () => this.setState(s => ({ showpass: !s.showpass }));

    notify = async (mode, msg) => {
        const opt = { position: "top-right", autoClose: 5000, closeOnClick: true, pauseOnHover: true, draggable: true, theme: "colored" };
        if (toast[mode]) await toast[mode](msg, opt);
    }
    async modalerror(object) { await this.notify(object.title === 'error' ? 'error' : object.title, object.text); }

    forgetotpandregister = async (type) => {
        const { phoneNumber, selectedBank, otp, accnumbertxt } = this.state;
        var recheck = false;
        if (type === 6) {
            await instance.post("/api/v1/resetpassword", { username: phoneNumber, System: Systems, type }).then(async (res) => { recheck = res.data.message; });
        } else if (type === 7) {
            await instance.post("/api/v1/resetpassword", { username: phoneNumber, pin: otp, System: Systems, type }).then(async (res) => { recheck = res.data.message; });
        } else if (type === 10) {
            return await instance.post("/api/v1/resetpassword", { accountnumber: accnumbertxt, bankid: selectedBank.id, System: Systems, type }).then(async (res) => { return recheck = res.data.message; });
        }
        return recheck;
    }

    validateBasic = () => {
        const { username, password } = this.state;
        // username ต้องเป็นเบอร์โทรศัพท์ 10 หลัก
        if (!/^[0-9]{10}$/.test(username)) { this.notify('warning', 'ชื่อผู้ใช้ต้องเป็นเบอร์โทรศัพท์ 10 หลัก'); return false; }
        // password อะไรก็ได้ แต่ยาว 8-16 ตัว
        if (!password || password.length < 8 || password.length > 16) { this.notify('warning', 'รหัสผ่านต้องยาว 8-16 ตัว'); return false; }
        return true;
    }

    startCountdown = (sec = 60) => {
        clearInterval(this.timer);
        this.setState({ countdown: sec });
        this.timer = setInterval(() => {
            this.setState(s => (s.countdown <= 1 ? (clearInterval(this.timer), { countdown: 0 }) : { countdown: s.countdown - 1 }));
        }, 1000);
    }

    fromBasic = async () => {
        if (this.state.loading) return;
        if (!this.validateBasic()) return;
        if (this.state.otpEnabled) {
            this.setState({ loading: true });
            const check = await this.forgetotpandregister(6);
            if (check && check.checked) {
                this.setState({ stateregis: STEP.OTP, refCode: check.ref || check.refno || this.genRef() });
                this.startCountdown(60);
            } else if (check && check.status === 201) { this.notify('warning', 'เบอร์นี้มีคนใช้แล้ว'); }
            else { this.notify('warning', 'ทำรายการถี่เกินไป โปรดรอสักครู่'); }
            this.setState({ loading: false });
        } else {
            this.setState({ stateregis: STEP.BANK });
        }
    }

    verifyOtp = async () => {
        if (this.state.loading) return;
        if (!this.state.otp || this.state.otp.length < 4) { this.notify('warning', 'กรุณากรอกรหัส OTP ให้ครบ'); return; }
        this.setState({ loading: true });
        const verify = await this.forgetotpandregister(7);
        if (verify && verify.checked) this.setState({ stateregis: STEP.BANK });
        else this.notify('error', 'รหัส OTP ไม่ถูกต้อง');
        this.setState({ loading: false });
    }

    resendOtp = async () => {
        if (this.state.countdown > 0) return;
        const check = await this.forgetotpandregister(6);
        if (check && check.checked) { this.setState({ refCode: check.ref || this.genRef() }); this.startCountdown(60); }
    }

    genRef = () => Math.random().toString(36).slice(2, 8).toUpperCase();
    toggleDropdown = () => this.setState((p) => ({ dropdownVisible: !p.dropdownVisible }));
    handleSelectBank = (bank) => this.setState({ selectedBank: bank, dropdownVisible: false });

    submitBank = async () => {
        if (this.state.loading) return;
        const { selectedBank, accnumbertxt } = this.state;
        if (!accnumbertxt) return this.modalerror({ title: 'error', text: 'คุณไม่ได้ใส่เลขบัญชีธนาคาร' });
        if (accnumbertxt.length < 10) return this.modalerror({ title: 'error', text: 'คุณใส่เลขบัญชีไม่ถูกต้อง' });
        if (Object.keys(selectedBank).length === 0) return this.modalerror({ title: 'error', text: 'คุณยังไม่ได้เลือกธนาคาร' });
        this.setState({ loading: true });
        let name = this.state.fname;
        if (selectedBank.id !== 99) {
            const check = await this.forgetotpandregister(10);
            if (check && check.checked) { if (check.verifications && check.verifications.status === 1) name = check.verifications.name; }
            else { this.setState({ loading: false }); return this.modalerror({ title: 'error', text: 'เลขบัญชีไม่ถูกต้อง' }); }
        }
        // ถ้า verify ไม่ได้ชื่อ (name ว่าง) → โชว์ช่องให้กรอกชื่อก่อน แล้วกดสมัครอีกครั้ง (กัน fallback เป็นเบอร์)
        if (!name || !name.trim()) {
            this.setState({ loading: false, needName: true });
            return this.modalerror({ title: 'error', text: 'ไม่พบชื่อบัญชีอัตโนมัติ กรุณากรอกชื่อ-นามสกุลเจ้าของบัญชี' });
        }
        await this.register(name);
        this.setState({ loading: false });
    }

    register = async (accName) => {
        const { username, password, phoneNumber, selectedBank, accnumbertxt, country, referral, userrecomend } = this.state;
        try {
            const res = await instance.post("/api/v1/register", {
                User_id: username, name: accName || username, password,
                phone: phoneNumber, accbank: selectedBank.id, accno: accnumbertxt,
                country: country.name, channel: referral, System: Systems, Useradvise: userrecomend,
            });
            if (res.data.status === 200) this.setState({ stateregis: STEP.SUCCESS });
            else if (res.data.status === 202) this.modalerror({ title: 'error', text: 'Username นี้ทำการสมัครไปแล้ว' });
            else if (res.data.status === 203) this.modalerror({ title: 'error', text: 'เลขบัญชีนี้ทำการสมัครไปแล้ว' });
            else this.modalerror({ title: 'error', text: 'ข้อมูลในการสมัครไม่ถูกต้อง' });
        } catch {
            Swal.fire({ title: 'ผิดพลาด!', text: 'ไม่สามารถเชื่อมต่อระบบได้', icon: 'error', confirmButtonText: 'ตกลง' });
        }
    }

    // เข้าสู่ระบบทันทีด้วยเบอร์+รหัสที่เพิ่งสมัคร (ไม่เด้งไปหน้า login)
    doLogin = async () => {
        const { username, password } = this.state;
        if (this.state.loading) return;
        this.setState({ loading: true });
        try {
            const res = await instance.post("/api/v1/userlogin", {
                userid: username,
                password: password,
                System: Systems,
                Function: 'validateLoginForm-register.js',
            });
            if (res.data.status === 200) {
                localStorage.setItem('auth_token', res.data.token);
                window.location.href = '/home';
                return;
            }
            this.notify('error', 'เข้าสู่ระบบไม่สำเร็จ');
        } catch {
            this.notify('error', 'ไม่สามารถเชื่อมต่อระบบได้');
        }
        this.setState({ loading: false });
    }

    // แปลง link-id (เช่น md5 hash จากลิงก์ reg=/aff=) ให้เป็น username ผู้แนะนำจริง แล้วเก็บไว้
    saveclickaff = async (linkid) => {
        try {
            const res = await instance.post("/api/v1/saveclickaff", {
                linkid: linkid,
                System: Systems,
            });
            if (res.data.status === 200) {
                const date = new Date();
                const username = res.data.username;
                this.setState({ userrecomend: username });
                localStorage.setItem('aff', JSON.stringify({ date, username }));
            }
        } catch (err) {
            console.log("[REGISTER:SAVE_CLICK_AFF_ERROR]", err);
        }
    };

    saveclick = async (linkid) => {
        try {
            const res = await instance.post("/api/v1/saveclickaff", {
                linkid: linkid,
                System: Systems,
            });
            if (res.data.status === 200) {
                const date = new Date();
                const username = res.data.username;
                this.setState({ userrecomend: username });
                localStorage.setItem('aff', JSON.stringify({ date, username }));
            }
        } catch (err) {
            console.log("[REGISTER:SAVE_CLICK_ERROR]", err);
        }
    };

    async componentDidMount() {
        [`${BASE}assets/1760337585578/entry.B2LNsUBP.css`, `${BASE}style.css`].forEach(href => {
            if (!document.querySelector(`link[href="${href}"]`)) {
                const link = document.createElement('link');
                link.rel = 'stylesheet'; link.href = href; link.setAttribute('data-register', '1');
                document.head.appendChild(link);
            }
        });
        const search = window.location.href;
        // ลิงก์แนะนำเพื่อนมาแบบ /register?reg=<hash> หรือ ?aff=<linkid>
        // ต้อง resolve ผ่าน /api/v1/saveclickaff ให้เป็น username ผู้แนะนำจริงก่อน ไม่งั้นส่ง hash ดิบไป backend จับคู่ไม่ได้
        const aff = search.split("aff=")[1];
        if (aff !== undefined) {
            this.saveclickaff(aff.split("&")[0]);
        }
        const reg = search.split("reg=")[1];
        if (reg !== undefined) {
            this.saveclick(reg.split("&")[0]);
            this.setState({ userrecomend: reg.split("&")[0] });
        }
        // ถ้าผู้ใช้คลิกลิงก์แล้วเดินเล่นในเว็บก่อนค่อยสมัคร (param หลุด) ให้ดึงจาก localStorage ที่เก็บไว้
        const tokenf = localStorage.getItem('aff');
        if (tokenf != null) {
            try {
                const codev = JSON.parse(tokenf);
                if (codev && codev.username) this.setState({ userrecomend: codev.username });
            } catch (err) { }
        }
        const tokenx = localStorage.getItem('register');
        if (tokenx != null) {
            try {
                const codev = JSON.parse(tokenx);
                if (codev && codev.username) this.setState({ userrecomend: codev.username });
            } catch (err) { }
        }

        // อ่าน tblbank จาก cache ก่อน (main.js เซฟ mainsetting ไว้) เพื่อให้ขึ้นไว
        try {
            const c = JSON.parse(localStorage.getItem('mainSettingCache'));
            const data = c && (c.value || c.data);   // รองรับ cache ทั้ง 2 ฟอร์แมต
            if (data && data.tblbank) {
                this.setState({
                    tblbank: data.tblbank,
                    logoimg: data.tblsetting?.[0]?.imglogo || this.state.logoimg,
                    linelink: data.message?.[1]?.value || this.state.linelink,
                });
            }
        } catch (e) { }

        // ดึงสดจาก API (แหล่งข้อมูลจริง)
        try {
            const res = await instance.post("/api/v1/mainsetting", { System: Systems });
            if (res.data.status === 200) {
                this.setState({
                    tblbank: res.data.tblbank || [],
                    logoimg: res.data.tblsetting[0].imglogo,
                    linelink: res.data.message[1].value,
                });
            }
        } catch (e) { }
    }

    componentWillUnmount() {
        clearInterval(this.timer);
        document.querySelectorAll('link[data-register]').forEach(l => l.remove());
    }

    // กรอบ field มาตรฐาน (เหมือนต้นฉบับ): w-[85%] ครอบ + inner flex mx-auto
    fieldFrame(children, extra = '') {
        return (
            <div className={`w-[85%] mt-3 ${extra}`}>
                {children}
            </div>
        );
    }

    render() {
        const {
            stateregis, otpEnabled, showpass, dropdownVisible, selectedBank,
            phoneCode, phoneFlag, country, referral, countrySearch, showCountry, showReferral, showLang,
            countdown, loading, linelink, logoimg, username, password,
        } = this.state;

        // แปลง URL จาก domain ภายนอกที่ mirror ไว้แล้ว -> path local (public/<host>/...)
        const toLocal = (u) => typeof u === 'string'
            ? u.replace('https://idea-bet.live', '/idea-bet.live').replace('https://member.appufa.org', '/member.appufa.org')
            : u;

        // ดึงรายการธนาคารจาก API (state.tblbank) แล้ว normalize ฟิลด์ให้ใช้ร่วมกับ UI เดิม
        const banks = (this.state.tblbank || []).map(b => ({
            id: b.bank_id ?? b.id,
            name: b.fullname_th ?? b.fullname_en ?? b.bank_name ?? b.name ?? b.acro ?? '',
            logo: toLocal(b.img_path ?? b.full_img ?? b.logo ?? b.img),
        }));
        const filteredCountries = COUNTRIES.filter(c => c.name.toLowerCase().includes(countrySearch.toLowerCase()) || c.dial.includes(countrySearch));
        const goldBtn = { color: 'black', background: BTN_GOLD, border: `1px solid ${GOLD2}` };

        // ===== real-time validate (bullet แดง→เขียว เหมือนต้นฉบับ) =====
        const userOk = /^[0-9]{10}$/.test(username);
        const pwLenOk = password.length >= 8 && password.length <= 16;
        const bullet = (ok) => `${BASE}images/layout/icn-check-bullet-${ok ? 'green' : 'red'}.svg`;

        return (
            <div id="login-main" className="w-full bg-cover bg-center mx-auto max-w-[438px] relative"
                style={{ backgroundImage: `url(${BASE}images/login-backdrop.webp)`, minHeight: '100vh' }}
                onClick={() => this.setState({ showLang: false, showCountry: false, showReferral: false })}>
                <ToastContainer />

                {/* ===== HEADER ===== */}
                <section>
                    <div style={{ height: 72 }}></div>
                    <div className="flex justify-between items-center p-4" style={{ position: 'fixed', top: 0, width: '100%', maxWidth: 438, zIndex: 100 }}>
                        <a href="/signin">
                            <div className="flex flex-row items-center cursor-pointer">
                                <img className="w-[28px] h-[28px]" src={`${BASE}images/layout/icn-down-small.svg`} style={{ transform: 'rotate(90deg)' }} alt="back" />
                                <span className="ml-2 text-sm" style={{ color: GOLD }}>เข้าสู่ระบบ</span>
                            </div>
                        </a>
                        <div className="flex flex-row items-center">
                            <div className="mr-4">
                                <a href={linelink} target="_blank" rel="noopener noreferrer">
                                    <div className="flex justify-around items-center social-media-box cursor-pointer social-media-box-line">
                                        <div className="ml-1 mr-1 p-1"><img className="icon-img w-[22px] h-[22px]" src={`${BASE}images/layout/icn-line.svg`} alt="" /></div>
                                        <div className="text-[#FFF] text-xs font-bold mr-3">ติดต่อเจ้าหน้าที่</div>
                                    </div>
                                </a>
                            </div>
                            <div onClick={e => { e.stopPropagation(); this.setState(s => ({ showLang: !s.showLang })); }}>
                                <img className="mx-auto w-[40px] h-[40px] cursor-pointer" src={`${BASE}images/language/icn-lang-th.svg`} alt="lang" />
                            </div>
                        </div>
                    </div>
                </section>

                {/* ===== BODY ===== */}
                <div className="min-h-[calc(100vh-72px)] pb-[100px]">
                    {/* โลโก้ */}
                    <div className="pt-[16%] mb-10">
                        <img className="mx-auto w-[80%] max-w-[438px]" src={toLocal(logoimg) || `${BASE}images/UFABET-LOGO.webp`} alt="UFABET" />
                    </div>

                    {/* การ์ดฟอร์ม */}
                    <div className="login-form mx-auto" style={{ background: FORM_BG, borderRadius: 10, padding: '11px 0', width: '77%', maxWidth: 338 }}>
                        {/* หัว */}
                        <div className="text-center text-xs text-white">คุณยังไม่ได้เป็นสมาชิกใช่ไหม?</div>
                        <div className="text-center text-xs text-white">สมัครสมาชิกเลย!</div>
                        <div className="w-[70%] h-0.5 bg-[#FBDEB226] bg-opacity-90 mt-4 mx-auto"></div>

                        {/* ===================== STEP 1 : ข้อมูลพื้นฐาน ===================== */}
                        {stateregis === STEP.BASIC && (
                            <div className="flex flex-col items-center mt-3">
                                <div className="flex items-center text-[#FBDEB2] text-xs mb-2 w-[85%]"><span className="mr-2">ข้อมูลพื้นฐาน</span></div>

                                {/* Username */}
                                <div className="w-[85%]">
                                    <div className="flex items-center text-[12px] mx-auto rounded-xl bg-[#00000080] bottom-animation relative mb-0">
                                        <div className="absolute mx-4"><img src={`${BASE}images/layout/icn-user.svg`} alt="icn" /></div>
                                        <div className="input-label w-[85%] ml-6">
                                            <div className="pl-6 opacity-50 relative top-2 text-[10px]" style={{ color: GOLD2 }}>ชื่อผู้ใช้ / Username</div>
                                            <input id="username-field" name="reg_username" type="text" inputMode="numeric" pattern="[0-9]*"
                                                value={username}
                                                onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()}
                                                onChange={e => this.setState({ username: e.target.value, phoneNumber: e.target.value })}
                                                className="w-[85%] ml-6 rounded-xl h-[40px] text-[12px] text-[#F5F5F5] bg-inherit border-none focus:outline-none custom-input"
                                                placeholder="ชื่อผู้ใช้ (เบอร์โทร 10 หลัก)" maxLength={10} autoComplete="off" autoCorrect="off" autoCapitalize="off" spellCheck="false" />
                                        </div>
                                    </div>
                                    <div className="profile-setting-container mx-8">
                                        <div className="flex text-xs" style={{ alignItems: 'center' }}>
                                            <div className="icon-container"><img className="w-1.5" src={bullet(userOk)} alt="" /></div>
                                            <div className="mt-2 ml-2" style={{ color: GOLD2 }}>ชื่อผู้ใช้ต้องเป็นเบอร์โทรศัพท์ 10 หลัก</div>
                                        </div>
                                        <div className="pb-2"></div>
                                    </div>
                                </div>

                                {/* Password */}
                                <div className="w-[85%] mt-3">
                                    <div className="flex items-center text-[12px] mx-auto rounded-xl bg-[#00000080] bottom-animation relative mb-0">
                                        <div className="absolute mx-4"><img src={`${BASE}images/layout/icn-password.svg`} alt="icn" /></div>
                                        <div className="input-label w-[85%] ml-6">
                                            <div className="pl-6 opacity-50 relative top-2 text-[10px]" style={{ color: GOLD2 }}>รหัสผ่าน / Password</div>
                                            <input id="password-field" name="reg_password" type={showpass ? "text" : "password"} value={password} onChange={e => this.setState({ password: e.target.value })}
                                                className="w-[85%] ml-6 rounded-xl h-[40px] text-[12px] text-[#F5F5F5] bg-inherit border-none focus:outline-none custom-input"
                                                placeholder="รหัสผ่าน / Password" maxLength={30} autoComplete="new-password" autoCorrect="off" autoCapitalize="off" spellCheck="false" />
                                        </div>
                                        <div className="relative flex ml-auto mr-4 cursor-pointer" onClick={this.changepass}><img className="w-[20px] h-[20px]" src={`${BASE}images/show-password.svg`} alt="pw-show" /></div>
                                    </div>
                                    <div className="profile-setting-container">
                                        <div className="flex text-xs" style={{ alignItems: 'center' }}><div className="icon-container"><img className="w-1.5" src={bullet(pwLenOk)} alt="" /></div><div className="mt-2 ml-2" style={{ color: GOLD2 }}>ความยาว 8-16 ตัวอักษร (ใส่อะไรก็ได้)</div></div>
                                        <div className="pb-2"></div>
                                    </div>
                                </div>

                                {/* Country */}
                                <div className="w-[85%] mt-3 relative">
                                    <div className="flex items-center text-[11px] min-h-[54px] mx-auto rounded-xl bg-[#00000080] bottom-animation">
                                        <div className="flex w-full relative">
                                            <div className="flex items-center mx-4 my-1 cursor-pointer w-full countryselect"
                                                onClick={e => { e.stopPropagation(); this.setState(s => ({ showCountry: !s.showCountry, showReferral: false })); }}>
                                                <div><span className={`fi fi-${country.flag} fis mt-[10px] text-[18px]`} title={country.flag}></span></div>
                                                <div className="top-1 whitespace-nowrap text-[10px] absolute ml-[30px]" style={{ color: GOLD2 }}>ประเทศ / Country</div>
                                                <div className="mt-4 text-[#FBDEB2] flex flex-row items-center flex-1"><span className="ml-3">{country.name}</span></div>
                                                <img className="mt-2 flex self-center w-[8px]" src={`${BASE}images/layout/icn-down-small.svg`} alt="" />
                                            </div>
                                        </div>
                                    </div>
                                    {showCountry && (
                                        <div className="w-full mt-1 bg-[#202020] border border-[#464646] rounded-lg absolute z-20" onClick={e => e.stopPropagation()}>
                                            <div className="p-2"><input type="text" value={countrySearch} onChange={e => this.setState({ countrySearch: e.target.value })} placeholder="ค้นหาประเทศ / Search" className="w-full h-[36px] px-3 rounded-lg text-[11px] text-[#F5F5F5] bg-black border border-[#464646] focus:outline-none" autoFocus /></div>
                                            <div className="max-h-[180px] overflow-y-auto">
                                                {filteredCountries.map(c => (
                                                    <div key={c.flag} className="flex flex-row mx-2 my-2 h-[30px] items-center rounded-md text-xs cursor-pointer hover:bg-white/10" style={{ color: GOLD }}
                                                        onClick={() => this.setState({ country: { flag: 'th', name: 'ประเทศไทย / Thailand' }, phoneCode: '+66', phoneFlag: 'th', showCountry: false, countrySearch: "" })}>
                                                        <div className="w-[20px] ml-2"><span className={`fi fi-${c.flag} fis`} style={{ fontSize: 18 }}></span></div>
                                                        <div className="ml-4">{c.name}</div>
                                                    </div>
                                                ))}
                                                {filteredCountries.length === 0 && <div className="text-center text-[#CDCDCD] text-xs py-3">ไม่พบประเทศ</div>}
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {/* ช่องเบอร์โทรเอาออกแล้ว — ใช้ช่องชื่อผู้ใช้เป็นเบอร์ (phoneNumber sync จาก username) */}

                                {/* รู้จักเราจากไหน */}
                                <div className="w-[85%] mt-1 relative">
                                    <div className="w-full text-[#FBDEB2] text-center text-xs mt-3 mb-1">รู้จักเราจากไหน</div>
                                    <div className="w-full">
                                        <div className="custom-dropdown-container flex flex-row justify-between items-center cursor-pointer bg-[#00000080] rounded-xl"
                                            onClick={e => { e.stopPropagation(); this.setState(s => ({ showReferral: !s.showReferral, showCountry: false })); }}>
                                            <div className="flex flex-row items-center mt-3 mb-3 ml-2">
                                                <div className="ml-2"><img src={`${BASE}images/layout/icn-register-source.svg`} alt="" /></div>
                                                <div className="flex flex-col">
                                                    <div className="ml-2 mb-1 relative text-[10px]" style={{ color: GOLD2 }}>คุณรู้จักเราจากไหน?</div>
                                                    <div className="ml-2 text-[#FFF] text-xs">{referral}</div>
                                                </div>
                                            </div>
                                            <div className="mr-3"><img className="w-[8px]" src={`${BASE}images/layout/icn-arrow-down.svg`} alt="icn" /></div>
                                        </div>
                                        {showReferral && (
                                            <div className="w-full mt-1 bg-[#202020] border border-[#464646] rounded-lg max-h-[200px] overflow-y-auto absolute z-20" onClick={e => e.stopPropagation()}>
                                                {REFERRALS.map(r => (
                                                    <div key={r} className="flex flex-row mx-2 my-2 h-[30px] items-center rounded-md text-xs cursor-pointer hover:bg-white/10" style={{ color: GOLD }}
                                                        onClick={() => this.setState({ referral: r, showReferral: false })}><div className="ml-4">{r}</div></div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {/* ปุ่มขั้นตอนต่อไป */}
                                <div className="w-full mt-4">
                                    <div className="w-full mb-[15px] cursor-pointer">
                                        <div className="flex flex-col relative w-[85%] mx-auto">
                                            <button onClick={this.fromBasic} disabled={loading} className="btn-primary rounded-xl mx-auto w-full h-[40px] flex items-center justify-center font-semibold cursor-pointer" style={{ ...goldBtn, opacity: loading ? 0.6 : 1 }}>
                                                <span className="font-semibold text-[14px]">{loading ? 'กำลังตรวจสอบ...' : 'ขั้นตอนต่อไป'}</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* ===================== STEP 2 : OTP (เมื่อ otpEnabled) ===================== */}
                        {stateregis === STEP.OTP && otpEnabled && (
                            <div className="mt-5">
                                <div className="w-[85%] mt-5 mx-auto flex flex-row justify-between">
                                    <div className="flex flex-col text-[#CDCDCD] text-[10px] text-nowrap">
                                        <div>OTP ส่งไปที่ {phoneCode} {this.state.phoneNumber}</div>
                                        <div>Ref Code: {this.state.refCode}</div>
                                    </div>
                                    <div className="ml-2 text-xs underline flex items-center text-[#FBDEB2] cursor-pointer" onClick={() => this.setState({ stateregis: STEP.BASIC, otp: '' })}>เปลี่ยนหมายเลข</div>
                                </div>
                                <div className="w-full mt-3 relative">
                                    <div className="flex items-center text-[12px] mb-4 w-[85%] mx-auto rounded-xl bg-[#00000080] bottom-animation relative">
                                        <div className="absolute mx-4"><img src={`${BASE}images/layout/icn-phone-verification.svg`} alt="icn" /></div>
                                        <div className="input-label w-[55%] ml-6">
                                            <input name="otp" type="text" inputMode="numeric" value={this.state.otp} onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()} onChange={this.onChange}
                                                className="w-full ml-6 rounded-xl h-[40px] text-[12px] text-[#F5F5F5] bg-inherit border-none focus:outline-none custom-input" placeholder="รหัสยืนยัน / code" maxLength={10} autoComplete="off" />
                                        </div>
                                        <div className="relative flex items-center mr-2 min-w-[100px]">
                                            <div className="w-full"><div className="flex flex-col relative w-[85%] mx-auto whitespace-nowrap">
                                                <button onClick={this.resendOtp} className="btn-primary rounded w-full h-[22px] flex items-center justify-center btn-click-animation whitespace-nowrap" style={{ color: 'black', background: '#E3BB72' }}>
                                                    <span className="font-medium text-[12px]">{countdown > 0 ? `รับรหัส (${countdown})` : 'รับรหัสยืนยัน'}</span>
                                                </button>
                                            </div></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="mt-4">
                                    <div className="w-full mb-[15px] cursor-pointer"><div className="flex flex-col relative w-[85%] mx-auto">
                                        <button onClick={this.verifyOtp} disabled={loading} className="btn-primary rounded-xl mx-auto w-full h-[40px] flex items-center justify-center font-semibold cursor-pointer" style={{ ...goldBtn, opacity: loading ? 0.6 : 1 }}>
                                            <span className="font-semibold text-[14px]">{loading ? 'กำลังตรวจสอบ...' : 'ขั้นตอนต่อไป'}</span>
                                        </button>
                                    </div></div>
                                    <div className="w-full mb-[15px] cursor-pointer"><div className="flex flex-col relative w-[85%] mx-auto">
                                        <button onClick={() => this.setState({ stateregis: STEP.BASIC, otp: '' })} className="btn-outline rounded-xl mx-auto w-full h-[40px] flex items-center justify-center font-semibold btn-click-animation cursor-pointer" style={{ color: '#BD9D4F', background: 'transparent', border: `1px solid ${GOLD2}` }}>
                                            <span className="font-semibold text-[14px]" style={{ color: '#BD9D4F' }}>กลับขั้นตอนก่อนหน้า</span>
                                        </button>
                                    </div></div>
                                </div>
                            </div>
                        )}

                        {/* ===================== STEP : บัญชีธนาคาร (เพิ่มใหม่) ===================== */}
                        {stateregis === STEP.BANK && (
                            <div className="flex flex-col items-center mt-3">
                                <div className="flex items-center text-[#FBDEB2] text-xs mb-2 w-[85%]"><span className="mr-2">บัญชีธนาคาร</span></div>
                                {/* เลือกธนาคาร */}
                                <div className="w-[85%] relative">
                                    <div className="flex items-center text-[12px] min-h-[54px] mx-auto rounded-xl bg-[#00000080] bottom-animation cursor-pointer" onClick={(e) => { e.stopPropagation(); this.toggleDropdown(); }}>
                                        <div className="ml-4"><img className="w-[22px]" src={`${BASE}images/layout/icn-user.svg`} alt="bank" /></div>
                                        <div className="flex-1 ml-4 text-[12px]" style={{ color: selectedBank.name ? '#F5F5F5' : '#9A9A9A' }}>{selectedBank.name || 'เลือกธนาคาร'}</div>
                                        <img className={`mr-4 w-[10px] ${dropdownVisible ? 'rotate-180' : ''}`} src={`${BASE}images/layout/icn-down-small.svg`} alt="" />
                                    </div>
                                    {dropdownVisible && (
                                        <div className="absolute z-50 w-full mt-1 rounded-xl border border-[#464646] bg-[#181818]" onClick={e => e.stopPropagation()}>
                                            <ul className="p-3 grid grid-cols-3 gap-3 max-h-[250px] overflow-y-auto">
                                                {banks.map((bank) => (
                                                    <li key={bank.value} className="text-center text-[11px] cursor-pointer text-white hover:opacity-80" onClick={() => this.handleSelectBank(bank)}>
                                                        <img src={bank.logo} alt={bank.name} className="w-2/4 block mx-auto mb-1" />{bank.name}
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                                </div>
                                {/* เลขที่บัญชี */}
                                <div className="w-[85%] mt-3">
                                    <div className="flex items-center text-[12px] min-h-[54px] mx-auto rounded-xl bg-[#00000080] bottom-animation">
                                        <div className="ml-4"><img className="w-[22px]" src={`${BASE}images/layout/icn-user.svg`} alt="acc" /></div>
                                        <input type="text" inputMode="numeric" onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()} maxLength={15} onChange={this.onChangex} id="accnumbertxt" name="accnumbertxt"
                                            className="flex-1 ml-4 mr-4 h-[40px] rounded-xl text-[12px] text-[#F5F5F5] bg-inherit border-none focus:outline-none" autoComplete="off" placeholder="เลขที่บัญชี" />
                                    </div>
                                </div>
                                {/* ชื่อบัญชี — โชว์ตอน TrueWallet หรือเมื่อ verify ไม่ได้ชื่อ (ให้ผู้ใช้กรอกเอง) */}
                                {(selectedBank.id === 99 || this.state.needName) && (
                                    <div className="w-[85%] mt-3">
                                        <div className="flex items-center text-[12px] min-h-[54px] mx-auto rounded-xl bg-[#00000080] bottom-animation">
                                            <div className="ml-4"><img className="w-[22px]" src={`${BASE}images/layout/icn-user.svg`} alt="" /></div>
                                            <input type="text" onChange={this.onChangex} id="fname" value={this.state.fname} name="fname"
                                                className="flex-1 ml-4 mr-4 h-[40px] rounded-xl text-[12px] text-[#F5F5F5] bg-inherit border-none focus:outline-none" autoComplete="off" placeholder="ชื่อบัญชี" />
                                        </div>
                                    </div>
                                )}
                                {/* ปุ่มสมัคร */}
                                <div className="w-full mt-4">
                                    <div className="w-full mb-[10px] cursor-pointer"><div className="flex flex-col relative w-[85%] mx-auto">
                                        <button onClick={this.submitBank} disabled={loading} className="btn-primary rounded-xl mx-auto w-full h-[40px] flex items-center justify-center font-semibold cursor-pointer" style={{ ...goldBtn, opacity: loading ? 0.6 : 1 }}>
                                            <span className="font-semibold text-[14px]">{loading ? 'กำลังสมัคร...' : 'สมัครสมาชิก'}</span>
                                        </button>
                                    </div></div>
                                    <div className="text-center text-xs mt-1" style={{ color: '#CDCDCD' }}>
                                        <a role="button" className="cursor-pointer" onClick={() => this.setState({ stateregis: otpEnabled ? STEP.OTP : STEP.BASIC })}>ย้อนกลับ</a>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* ===================== STEP : สำเร็จ ===================== */}
                        {stateregis === STEP.SUCCESS && (
                            <div className="flex flex-col items-center justify-center gap-3 py-6">
                                <h2 className="text-xl" style={{ color: GOLD }}>สมัครสมาชิกสำเร็จ!</h2>
                                <div className="w-[85%] rounded-xl bg-[#00000080] border border-white/20 p-4 text-center space-y-2">
                                    <div className="text-xs text-[#CDCDCD]">ข้อมูลเข้าสู่ระบบของคุณ</div>
                                    <div className="text-sm text-white">Username : <span style={{ color: GOLD }}>{username}</span></div>
                                    <div className="text-sm text-white">Password : <span style={{ color: GOLD }}>{password}</span></div>
                                </div>
                                <div className="w-[85%]">
                                    <button onClick={this.doLogin} disabled={loading} className="btn-primary rounded-xl w-full h-[40px] flex items-center justify-center font-semibold cursor-pointer" style={{ ...goldBtn, opacity: loading ? 0.6 : 1 }}>
                                        <span className="font-semibold text-[14px]">{loading ? 'กำลังเข้าสู่ระบบ...' : 'เข้าสู่ระบบ'}</span>
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>

                    {/* footer: มีบัญชีอยู่แล้ว */}
                    <div className="flex flex-row justify-center items-center mt-6 mx-4">
                        <div className="text-[#FFF] text-sm">มีบัญชีอยู่แล้ว?</div>
                        <div className="w-[100px] ml-4">
                            <a href="/signin"><div className="border border-1 border-[#FDD387] text-[#ECCA77] font-normal text-sm rounded-xl w-full flex items-center justify-center btn-click-animation p-2">เข้าสู่ระบบ</div></a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default App;
